<div class="side-panel-section-item-container display-flex flex-column">
  <ng-container [ngTemplateOutlet]="sectionItem.separator ? separator : menuItem"></ng-container>
</div>

<ng-template #menuItem>
  <div
    class="section-button display-flex"
    [ngClass]="[isActive ? 'active' : '']"
    tabindex="0"
    (keydown.enter)="open(sectionItem)"
    (click)="open(sectionItem)"
  >
    <div class="side-panel-section-item-content">
      {{ sectionItem.label }}
    </div>
    <button *ngIf="sectionItem?.sectionItem?.length" mat-icon-button class="ml-auto" (click)="toggleSection($event)">
      <app-icon
        [iconColor]="EColorPalette.cGray4"
        [iconHeight]="5"
        [iconWidth]="8"
        [svg]="isExpanded ? EIcon.ANGLE_UP : EIcon.ANGLE_DOWN"
      ></app-icon>
    </button>
  </div>
  <div *ngIf="isExpanded" class="subsection-list display-flex flex-column">
    <div
      *ngFor="let item of sectionItem?.sectionItem"
      class="subsection-button display-flex"
      [ngClass]="[activeSection == item ? 'active' : '']"
      tabindex="0"
      (keydown.enter)="open(item)"
      (click)="open(item)"
    >
      <div class="side-panel-section-item-content">
        {{ item.label }}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #separator>
  <div class="separator"></div>
</ng-template>
